import { useEffect, useState } from 'react'

import { getPost } from '@/services/wordpress.service'
import { PostType } from '@/types/wordpress'

import ArticlePreview from '../ArticlePreview/ArticlePreview'

type ReadMorePreviewProps = { slug: string }

const ReadMorePreview = ({ slug }: ReadMorePreviewProps) => {
  const [post, setPost] = useState<PostType>()

  useEffect(() => {
    const fetch = async () => {
      const postNode = await getPost(slug)
      setPost(postNode as PostType)
    }

    fetch()
  }, [])

  if (!post) return

  return <ArticlePreview {...post} />
}

export default ReadMorePreview
